// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { mobileTippyStyle } from "@pace/App/ComponentExtensions/Tippy/TippyPopupExtensions";
import { hideLoadingOverlay } from "@pace/App/Components/Common/XngLoadingOverlayUtilities";
import { xBaseTheme } from "@pace/XDL/types";
import { color } from "@pace/XDL/Utilities";
import { css } from "styled-components";

export const zIndexLoadingOverlay = 1500;


export const xngLoadingOverlayUtilitiesStyles = css`
    #xng-loading-overlay {
        width: 100%;
        position: fixed;
        height: 100%;
        z-index: ${zIndexLoadingOverlay};
        top: 0;
        bottom: 0;
        @media print {
            display: none;
        }
    }
`;

export default {
    css: css`
        ${hideLoadingOverlay}
        ${xngLoadingOverlayUtilitiesStyles}
        ${mobileTippyStyle}
        body {
            &:after {
                transition: all 0.2s linear;
                content: "";
                position: fixed;
                top: 0;
                left: 0;
                z-index: ${getProp("theme.zIndex.shade")};
                width: 100%;
                height: 100%;
                pointer-events: none;
            }
            &.shade {
                &:after {
                    background-color: ${color("common.ui7", 0.7)};
                }
            }
        }
    `,
} as xBaseTheme["globalStyle"];
